// React Router
import { Navigate, Route, Routes } from "react-router-dom";
// Page Layouts
import AppLayout from "../layouts/AppLayout";
import MapLayout from "../layouts/MapLayout";
// Proctect Component Routes
import RequireUser from "../components/protectedRoutes/RequireUser";
import RequireAdmin from "../components/protectedRoutes/RequireAdmin";
// Pages
import HomePage from "../pages/HomePage";
import UserAuthPage from "../pages/UserAuthPage";
import MapPage from "../pages/MapPage";
import AdminAuthPage from "../pages/AdminAuthPage";
import NotFoundPage from "../pages/NotFoundPage";
import AdminDashboardPage from "../pages/AdminDashboardPage";

function AppRoutes() {
  return (
    <Routes>
      {/* AppLayout is a wrapper all pages that use this layout will have the same web layout i.e same top navigation and page structure */}
      <Route element={<AppLayout />}>
        <Route index element={<HomePage />} />
        <Route path="/auth" element={<UserAuthPage />} />
        <Route path="/admin" element={<AdminAuthPage />} />
      </Route>

      {/* MapLayout is a wrapper all pages that use this layout will have the same web layout */}
      <Route element={<MapLayout />}>
        <Route
          path="/map"
          element={
            <RequireUser>
              <MapPage />
            </RequireUser>
          }
        />
      </Route>

      {/* Protected Amind Dashboard Page*/}
      <Route
        path="/dashboard"
        element={
          <RequireAdmin>
            <AdminDashboardPage />
          </RequireAdmin>
        }
      />

      {/* Automatically redirect users from /home to /  e.g if someone types website.com/home they are immediately sent to the main homepage.*/}
      <Route path="/home" element={<Navigate to="/" replace />} />

      {/* Show 404 page if route doesn't exist */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default AppRoutes;
